import { Routes } from '@angular/router';
import { productGuard } from 'app/core/guards/product.guard';

export const planRoutes: Routes = [
    {
        path: 'dashboard/rooms-planning',
        title: 'Rooms Planning',
        canActivate: [productGuard('plan')],
        loadComponent: () =>
            import('app/products/forecasting-tool/dashboards/rooms-planning/rooms-planning.component').then(
                m => m.RoomsPlanningDashboardComponent
            ),
    },
    {
        path: 'dashboard/fd-planning',
        title: 'F&D Planning',
        canActivate: [productGuard('plan')],
        loadComponent: () =>
            import('app/products/forecasting-tool/dashboards/fd-planning/fd-planning.component').then(
                m => m.FDPlanningDashboardComponent
            ),
    },
    {
        path: 'dashboard/me-planning',
        title: 'M&E Planning',
        canActivate: [productGuard('plan')],
        loadComponent: () =>
            import('app/products/forecasting-tool/dashboards/me-planning/me-planning.component').then(
                m => m.MEPlanningDashboardComponent
            ),
    },
    {
        path: 'dashboard/mod-planning',
        title: 'MOD Planning',
        canActivate: [productGuard('plan')],
        loadComponent: () =>
            import('app/products/forecasting-tool/dashboards/mod-planning/mod-planning.component').then(
                m => m.MODPlanningDashboardComponent
            ),
    },
    {
        path: 'dashboard/rooms-planning-admin',
        title: 'Market Code Mapping',
        canActivate: [productGuard('plan')],
        loadComponent: () =>
            import('app/products/forecasting-tool/dashboards/market-code-mapping/market-code-mapping.component').then(
                m => m.MarketCodeMappingDashboardComponent
            ),
    },
    {
        path: 'dashboard/trx-code-mapping',
        title: 'Revenue Mapping',
        canActivate: [productGuard('plan')],
        loadComponent: () =>
            import('app/products/forecasting-tool/dashboards/mapping/trx-code-mapping/trx-code-mapping.component').then(
                m => m.TrxCodeMappingDashboardComponent
            ),
    },
    {
        path: 'dashboard/bpc-planning-mapping',
        title: 'BPC Code Mapping',
        canActivate: [productGuard('plan')],
        loadComponent: () =>
            import('app/products/forecasting-tool/dashboards/bpc-code-mapping/bpc-code-mapping.component').then(
                m => m.BpcCodeMappingDashboardComponent
            ),
    },
    {
        path: 'dashboard/forecasting-tool-lock-admin',
        title: 'Forecasting Tool Lock Admin',
        canActivate: [productGuard('plan')],
        loadComponent: () =>
            import('app/products/forecasting-tool/dashboards/lock-admin/lock-admin.component').then(
                m => m.ForecastingToolLockAdminDashboardComponent
            ),
    },
    {
        path: 'dashboard/forecasting-tool-unlock-view',
        title: 'Forecasting Tool Unlock View',
        canActivate: [productGuard('plan')],
        loadComponent: () =>
            import('app/products/forecasting-tool/dashboards/unlock-view/unlock-view.component').then(
                m => m.ForecastingToolUnlockViewDashboardComponent
            ),
    },
    {
        path: 'dashboard/forecasting-tool-calendar',
        title: 'Forecasting Tool Calendar',
        canActivate: [productGuard('plan')],
        loadComponent: () =>
            import('app/products/forecasting-tool/dashboards/submission-calendar/submission-calendar.component').then(
                m => m.ForecastingToolSubmissionCalendarComponent
            ),
    },
    {
        path: 'dashboard/rollup-planning',
        title: 'Pulse Plan Rollup',
        canActivate: [productGuard('plan')],
        loadComponent: () =>
            import('app/products/forecasting-tool/dashboards/rollup-planning/rollup-planning.component').then(
                m => m.RollupPlanningDashboardComponent
            ),
    },
    {
        // Path matches the `outlet-calendar` dashboard_id registered in
        // sys_pulse.app_dashboard under the forecasting_tool menu. As in
        // pulseWeb, the Outlet Closure screen serves that dashboard.
        path: 'dashboard/outlet-calendar',
        title: 'Outlet Closure',
        canActivate: [productGuard('plan')],
        loadComponent: () =>
            import('app/products/forecasting-tool/dashboards/outlet/outlet-closure/outlet-closure.component').then(
                m => m.OutletClosureDashboardComponent
            ),
    },
];
